import React from 'react';
import {ContactText} from './styled';

const ContactField = ({Icon, line1, line2}) => (
  <div style={{display: 'flex', marginTop: 15, marginBottom: 30}}>
    {Icon}
    <div>
      <ContactText>{line1}</ContactText>
      <ContactText>{line2}</ContactText>
    </div>
  </div>
);

export default ContactField;
